import React from 'react';

interface ErrorDisplayProps {
  error: string | null | undefined;
  onClearError: () => void;
  t: any;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onClearError, t }) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg md:rounded-xl p-3 md:p-4">
      <div className="flex items-start">
        <span className="text-red-500 mr-2 md:mr-3 text-base md:text-lg">⚠️</span>
        <div className="flex-1">
          <div className="text-red-800 font-medium text-sm md:text-base">{t('error.title')}</div>
          <div className="text-red-700 text-xs md:text-sm mt-1">{error}</div>
          <button onClick={onClearError} className="text-red-600 text-xs md:text-sm underline mt-1.5 md:mt-2 hover:text-red-800">
            {t('error.dismiss')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;